import { Controller } from 'react-hook-form'
import AutoComplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { useTranslation } from 'next-i18next'

const ControlledAutoComplete = ({
  control,
  options,
  label,
  defaultValue,
  name,
  disableClearable = false,
  disableDefaultFilter = false,
  loading = false,
  controllerProps = {},
  autoCompleteProps = {},
  textFieldProps = {},
}) => {
  // the field value from auto complete will be the option object
  // Option Object: { value, label }
  
  const { t } = useTranslation('common')

  let disableFilterProps = {}
  if (disableDefaultFilter) {
    disableFilterProps.filterOptions = (option, _) => option
  }

  return (
    <Controller
      render={({ onChange, value, ...props }) => (
        <AutoComplete
          options={options}
          getOptionLabel={(option) => option.label}
          getOptionSelected={(option, value) => {
            return option.value === value.value
          }}
          renderInput={(params) => (
            <TextField {...params} label={label} variant="outlined" {...textFieldProps} />
          )}
          onChange={(e, data) => onChange(data)}
          value={value}
          disableClearable={disableClearable}
          noOptionsText={t('no-options')}
          loading={loading}
          {...disableFilterProps}
          {...props}
          {...autoCompleteProps}
        />
      )}
      defaultValue={defaultValue}
      name={name}
      control={control}
      {...controllerProps}
    />
  )
}

export default ControlledAutoComplete
